export default "__VITE_ASSET__37085005__"